var $35f135b45eb4d95b$exports = {};
$35f135b45eb4d95b$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selettore colore`,
    "colorSwatch": `campione di colore`,
    "transparent": `trasparente`,
    "twoDimensionalSlider": `Cursore 2D`
};


export {$35f135b45eb4d95b$exports as default};
//# sourceMappingURL=it-IT.module.js.map
